import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { SyncIntroModalBody } from './sync-intro-modal-body';
import { SyncSpaceModalBody } from './sync-space-modal-body';
import { SyncFlowFooter } from './sync-flow-footer';

export const ModalSyncSteps = ({
  changeModal,
  body = {},
  nextModal,
  previousModal,
  length,
  index = 0,
  showModal,
  ...props
}) => {
  const components = {
    SyncIntroModalBody,
    SyncSpaceModalBody
  };
  const ModalBody = components[body.componentName || 'SyncIntroModalBody'];
  return (
    <BootstrapModal
      showModal={showModal}
      body={
        <ModalBody
          {...body}
          {...props}
          ctaAction={() => changeModal(nextModal) }
        />
      }
      bodyClass="sync-modal-body text-center"
      footer={
        <SyncFlowFooter
          totalLength={length}
          currentIndex={index}
          backAction={() => changeModal(previousModal) }
        />
      }
      toggleModal={changeModal}
      onClose={() => {
        props.clearHashUrl();
        props.toggleModal('');
      }}
    />
  );
};

ModalSyncSteps.propTypes = {
  changeModal: PropTypes.func,
  showModal: PropTypes.bool,
  body: PropTypes.object,
  length: PropTypes.number,
  index: PropTypes.number,
  nextModal: PropTypes.string,
  previousModal: PropTypes.string,
  clearHashUrl: PropTypes.func,
  toggleModal: PropTypes.func
};
